<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      append-to-body
      title="监控专查"
      width="1700px"
      custom-class="channel-imgs-dialog"
    >
      <div class="img-list">
        <div class="img-item" v-for="item in imgList" :key="item.url">
          <el-image v-if="item.url" :src="item.url" :preview-src-list="previewList" lazy></el-image>
          <div v-else class="img-item-empty">
            <div class="img-item-empty-text">暂无图片</div>
          </div>

          <div class="img-item-info">
            <div class="time">{{ item.createTime | dateFormat("hh:mm:ss") }}</div>
            <div class="btn">
              <el-button type="text" size="small" @click="download(item)"
                >下载前后3分钟视频</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="taskVisible"
      width="600px"
      max-height="600"
      size="small"
      title="创建任务"
      :close-on-click-modal="false"
    >
      <el-form ref="form" size="small" :model="form" label-width="120px">
        <el-form-item label="通道：" prop="channels">
          <el-select
            v-model="form.channels"
            style="width: 300px"
            placeholder="请选择"
            multiple
            clearable
          >
            <el-option
              v-for="item in chnOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="开始时间：" prop="startTime">
          <el-date-picker
            style="width: 300px"
            placeholder="选择时间"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="form.startTime"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="结束时间：" prop="endTime">
          <el-date-picker
            style="width: 300px"
            placeholder="选择时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            v-model="form.endTime"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="备注：" prop="remark">
          <el-input v-model="form.remark" style="width: 300px"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button type="warning" :size="size" @click="createTask">保存</el-button>
        <el-button type="info" :size="size" @click="taskVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { addBackendDownloadTask } from "@/api";
import moment from "moment";
export default {
  components: {},

  props: {},

  watch: {},

  created() {},

  mounted() {},

  computed: {
    previewList() {
      return this.imgList.map((item) => item.url);
    }
  },

  data() {
    return {
      size: "small",
      imgList: [],
      visible: false,
      taskVisible: false,
      chnOptions: [
        { value: 0, label: "通道1" },
        { value: 1, label: "通道2" },
        { value: 2, label: "通道3" },
        { value: 3, label: "通道4" }
      ],
      form: {
        channels: [],
        startTime: "",
        endTime: "",
        remark: ""
      }
    };
  },

  methods: {
    show(imgs, driverId, channelId) {
      this.imgList = imgs.filter((item) => item.url);
      this.visible = true;
      this.driverId = driverId;
      this.channelId = channelId;
    },

    download(item) {
      const startTime = moment(item.createTime)
        .subtract(3, "minutes")
        .format("YYYY-MM-DD HH:mm:ss");
      const endTime = moment(item.createTime).add(3, "minutes").format("YYYY-MM-DD HH:mm:ss");
      this.form = {
        driverId: this.driverId,
        channels: [0, 1, 2, 3],
        startTime,
        endTime,
        remark: "质检专项查询"
      };
      this.taskVisible = true;
    },

    createTask() {
      this.$refs.form.validate().then(() => {
        addBackendDownloadTask(this.form).then(() => {
          this.$message.success("创建成功");
          this.taskVisible = false;
        });
      });
    }
  }
};
</script>
<style scoped lang="less">
.img-list {
  display: flex;
  flex-wrap: wrap;
  max-height: 700px;
  overflow-y: auto;

  .img-item {
    margin-right: 10px;
    margin-bottom: 10px;

    .el-image {
      width: 300px;
      height: 180px;
    }

    .img-item-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }
  }
}
/deep/ .channel-imgs-dialog {
  margin-top: 20px !important;
}
</style>
